<template>
  <component @[event]="$emit(event,$event)"
             viewBox="0 0 258 60"
             :class="name"
             :stroke="stroke"
             role="presentation"
             :fill="color"
             :is="component"
             v-if="component" />
</template>
<script>
import logo_header_agro_ongeo from './templates/logo_header_agro_ongeo.vue';
import logo_header_blog_ongeo from './templates/logo_header_blog_ongeo.vue';
import logo_header_nieruchomosci_ongeo from './templates/logo_header_nieruchomosci_ongeo.vue';
import logo_header_rapoty_o_terenie_ongeo from './templates/logo_header_rapoty_o_terenie_ongeo.vue';
import logo_header_wszystko_o_lokalizacji_ongeo from './templates/logo_header_wszystko_o_lokalizacji_ongeo.vue';
import logo_header_api_ongeo from './templates/logo_header_api_ongeo.vue';

export default {
  props: {
    name: {
      type: String,
      default: null
    },
    event: {
      default: null,
      type: String
    },
    stroke: {
      type: String,
      default: 'none'
    },
    color: {
      type: String,
      default: 'black'
    },
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    logo_header_rapoty_o_terenie_ongeo,
    logo_header_nieruchomosci_ongeo,
    logo_header_agro_ongeo,
    logo_header_blog_ongeo,
    logo_header_wszystko_o_lokalizacji_ongeo,
    logo_header_api_ongeo
  },
  data () {
    return {
      component: null,
    }
  },
  watch: {
    name (value) {
      this.loadTemplate(value);
    }
  },
  methods: {
    loadTemplate (name) {
      this.component = name;
    }
  },
  mounted () {
    if (this.name)
      this.loadTemplate(this.name);
  }
}
</script>
<style lang="scss" scoped>
svg {
  cursor: pointer;
  &.click {
    cursor: pointer;
  }
}
</style>

